import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=25c1029d"
import script from "./BlackList.vue?vue&type=script&lang=js"
export * from "./BlackList.vue?vue&type=script&lang=js"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=25c1029d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports